import * as React from "react";
import IConfirmation from "./IConfirmation";
import CheckedMark from "@appComponents/CheckedMark/CheckedMark";
import { Button } from "antd";

import * as style from "./ConfirmationStyle.module.scss";

const Confirmation = (props: IConfirmation) => {
  return (
    <div className={style.container}>
      {props.icon || <CheckedMark />}
      <h2 data-cy="confirmation-headline">{props.data.title}</h2>
      {props.data.texts.map((text, i) => (
        <span data-cy="confirmation-text" key={`${i}confirmation`}>
          {text}
        </span>
      ))}
      {props.children && <div>{props.children}</div>}
      {(props.data.link1 || props.data.link2) && (
        <div className={style.buttons}>
          {props.data.link1 && (
            <Button
              type="primary"
              onClick={
                props.data.link1?.url
                  ? () => window.open(props.data.link1?.url ?? "/", "_self")
                  : props.data.link1?.onClick
              }
            >
              {props.data.link1.text}
            </Button>
          )}
          {props.data.link2 && (
            <Button
              type="link"
              onClick={
                props.data.link2?.url
                  ? () => window.open(props.data.link2?.url ?? "/", "_self")
                  : props.data.link2?.onClick
              }
            >
              {props.data.link2.text}
            </Button>
          )}
        </div>
      )}
    </div>
  );
};

export default Confirmation;
